import React, { useEffect, useState } from "react"
import Select from "react-select"
import { OtpInput } from "./OtpInput"
import { Button } from "./Button"
import { TimerDisplay } from "./TimerDisplay"
import { PVSNumberInput } from "./PVSNumberInput"
import { useDispatch, useSelector } from "react-redux"
import { getOTPPVSRequest, loginRequest } from "../../redux/actions/auth"
import { GET_OTP_PVS_RESET, LOGIN_RESET } from "../../redux/types/auth"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { Label } from "reactstrap"
import ErrorPopup from "components/ErrorPopup"

export const LoginFormPvs = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  const [mobileNumber, setMobileNumber] = useState("")
  const [otp, setOtp] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [showOtpInput, setShowOtpInput] = useState(false)
  const [isNumberLocked, setIsNumberLocked] = useState(false)
  const [countdown, setCountdown] = useState(0)
  const [selectedGroup, setselectedGroup] = useState({
    label: "PVS_2018_",
    value: "PVS_2018_",
  })

  const pvsOtpResult = useSelector(state => state.auth.pvsOtpResult)
  const pvsOtpMessage = useSelector(state => state.auth.pvsOtpMessage)
  const getOTPPVSScreen = useSelector(state => state.screens.getOTPPVS)
  const loginScreen = useSelector(state => state.screens.login)
  const user = useSelector(state => state.auth.user)


  useEffect(() => {
    if (getOTPPVSScreen.success) {
      setShowOtpInput(true)
      setIsNumberLocked(true)
      setCountdown(60)
      dispatch({ type: GET_OTP_PVS_RESET })
    }

    if (loginScreen.success) {
      setIsNumberLocked(false)
      setShowOtpInput(false)
      setOtp("")
      setCountdown(0)
      dispatch({ type: LOGIN_RESET })
      if (props.state && props.state.from) {
        navigate(props.state.from, { replace: true })
      } else {
        if (user && (user.user_type == "admin" || user.user_type == "staff")) {
          navigate("/dashboard", { replace: true })
        } else if (user && user.user_type == "volunteer") {
          navigate("/volunteer/bazaars", { replace: true })
        } else navigate("/home", { replace: true })
      }
    }

    if (loginScreen.error) {
      toast.error(loginScreen.error || "Login failed. Please try again.")
      dispatch({ type: LOGIN_RESET })
    }

    if (getOTPPVSScreen.error) {
      setIsErrorMessage(getOTPPVSScreen.error)
      setIsErrorOpen(true)
    }
  }, [getOTPPVSScreen, loginScreen])

  const handleGetOTP = e => {
    e.preventDefault()

    dispatch(
      getOTPPVSRequest({
        pvs_card_number: `${selectedGroup.value}${mobileNumber}`,
      })
    )
    // setShowOtpInput(true)
    // setIsNumberLocked(true)
    // setCountdown(60)
  }

  const handleLogin = async e => {
    e.preventDefault()

    dispatch(
      loginRequest({
        mobile_no: pvsOtpResult.mobile.mobile_no,
        mobile_otp: otp,
        login_with: "pvs_card",
      })
    )
  }

  const resendOTP = () => {
    dispatch(
      getOTPPVSRequest({
        pvs_card_number: `${selectedGroup.value}${mobileNumber}`,
      })
    )
  }

  const handleEdit = () => {
    setIsNumberLocked(false)
    setShowOtpInput(false)
    setOtp("")
    setCountdown(0)
  }

  React.useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
      return () => clearTimeout(timer)
    }
  }, [countdown])

  const isGetOtpValid = mobileNumber.length > 0 && !showOtpInput
  const isLoginValid = otp.length === 4 && showOtpInput

  const optionGroup = [
    { label: "PVS_2018_", value: "PVS_2018_" },
    { label: "PVS_2021_", value: "PVS_2021_" },
  ]
  function handleSelectGroup(selectedGroup) {

    setselectedGroup(selectedGroup)
  }

  return (
    <form
      onSubmit={showOtpInput ? handleLogin : handleGetOTP}
      className="login-form"
    >
      <fieldset className="form-fieldset">
        <legend className="sr-only">Mobile Number Authentication</legend>

        <div className="label-container">
          <label htmlFor="mobile-number" className="label">
            Enter PVS Card Number
          </label>
          {isNumberLocked && (
            <button type="button" onClick={handleEdit} className="edit-button">
              Edit
            </button>
          )}
        </div>

        <div
          className="input-group login-pvs-wrapper"
          role="group"
          aria-labelledby="mobile-input-group"
        >
          <div>
            <Select
              value={selectedGroup}
              onChange={handleSelectGroup}
              options={optionGroup}
              isSearchable={false}
              menuPortalTarget={document.body} // ✅ KEY FIX
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
              }}
              placeholder="PVS_XXXX_"
              className="selectedPvs"
              classNamePrefix="select2-selection"
            />
          </div>
          <PVSNumberInput
            value={mobileNumber}
            placeholder="Last digits of PVS e.g A112"
            onChange={setMobileNumber}
            disabled={isLoading || isNumberLocked}
            className="pvs_number"
          />
        </div>
        {showOtpInput && (
          <span>
            <label htmlFor="otp-input" className="footer-title font-size-13">
              {pvsOtpMessage}&nbsp;
              <i className="ion ion-logo-whatsapp"></i>
            </label>
          </span>
        )}

        {showOtpInput && (
          <div className="otp-section">
            OTP
            <OtpInput value={otp} onChange={setOtp} disabled={isLoading} />
            {countdown > 0 ? (
              <div className="otp-timer-container">
                <TimerDisplay seconds={countdown} />
              </div>
            ) : (
              <div className="otp-timer-container">
                <button
                  type="button"
                  onClick={resendOTP}
                  className="edit-button"
                >
                  Resend OTP
                </button>
              </div>
            )}
          </div>
        )}

        <div className="button-container">
          <Button
            type="submit"
            disabled={(!isGetOtpValid && !isLoginValid) || isLoading}
            variant={isGetOtpValid || isLoginValid ? "active" : "default"}
            aria-describedby="button-help"
          >
            {isLoading ? "Loading..." : showOtpInput ? "Login" : "Get OTP"}
          </Button>
          <div id="button-help" className="sr-only">
            {showOtpInput
              ? "Click to login with your OTP"
              : "Click to receive a one-time password on your WhatsApp number"}
          </div>
        </div>
      </fieldset>
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="System Under Development"
        message={isErrorMessage}
      />
    </form>
  )
}
